import React, { useEffect, useRef, useState } from 'react';
import './inputUrl.style.scss';
import { __InputUrlProps, __InputURLRef } from './inputUrl.interface';
import { ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { urlValidation } from 'scripts/validation';
import { extractTitle } from 'scripts/string';
export interface SLPInputURLRef extends __InputURLRef {}
const SLPInputURL: React.ForwardRefRenderFunction<__InputURLRef, ConnectedProps<typeof connector> & __InputUrlProps> = (
    props: ConnectedProps<typeof connector> & __InputUrlProps,
    ref,
) => {
    const lang = props.lang.utilities;
    const inputRef = useRef<HTMLInputElement>(null);
    const [error, setError] = useState<string>();
    // const [disabled, setDisabled] = useState<boolean>(false);
    const [active, setActive] = useState<boolean>(false);
    const immediateValue = useRef(props.defaultValue ? props.defaultValue : '');
    const [value, setValue] = useState<string>(immediateValue.current);
    const labelRef = useRef<HTMLLabelElement>(null);

    React.useImperativeHandle(ref, () => ({
        getValue: () => (inputRef.current ? inputRef.current.value : ''),
        // setValue,
        getValidation: () =>
            (props.required !== true && immediateValue.current.length === 0) || urlValidation(immediateValue.current),
        setError: (text) => {
            setError(text);
        },
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    function onblurHandler() {
        setActive(false);
    }

    function onChangeHandler(e: any) {
        setError(undefined);
        immediateValue.current = e.target.value;
        setValue(immediateValue.current);
        if (props.onChange) props.onChange(immediateValue.current);
    }

    function onKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.charCode === 13 && props.onEnter) {
            e.preventDefault();
            e.currentTarget.blur();
            props.onEnter(immediateValue.current);
        }
    }
    return (
        <div
            onClick={() => inputRef.current?.focus()}
            className={`ucheck-SLP-url-input ${value.length ? 'filled' : ''} ${active ? 'active' : ''} ${
                error ? 'error' : ''
            } ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}
        >
            <div className="input-header">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </div>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className={`input-container ${props.endIcon ? 'has-end-icon' : ''} `}>
                <input
                    ref={inputRef}
                    type="text"
                    value={value}
                    onFocus={() => setActive(true)}
                    onBlur={onblurHandler}
                    required={props.required}
                    onChange={onChangeHandler}
                    style={{ color: props.color }}
                    placeholder={lang.SLPWebsitePH}
                    onKeyPress={onKeyPress}
                    enterKeyHint="next"
                />
                {props.endIcon && (
                    <i className="material-icons" style={{ color: props.endIcon.color }}>
                        {props.endIcon.icon}
                    </i>
                )}
            </div>
            {error && <p className="input-error">{error}</p>}
        </div>
    );
};
const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPInputURL));
